import { FC, useContext } from "react";
import { BreakPointContext } from "../../../../context/BreakPointContext";
import { UserVehicleControl } from "../../../../../domain/control/Vehicle";
import { VehicleControlList } from "../../../data-display/vehicle-control-list";
import { VehicleControlTable } from "../../../data-display/vehicle-control-table";

type Props = {
  vehicleControlList?: UserVehicleControl[];
  onSelect: (item: UserVehicleControl) => void;
};

export const UserVehicleControlDataName = "UserVehicleControlData";

export const UserVehicleControlData: FC<Props> = ({
  vehicleControlList,
  onSelect,
}) => {
  const screenSize = useContext(BreakPointContext);
  if (screenSize.isMobile) {
    return (
      <VehicleControlList
        name={UserVehicleControlDataName}
        onSelect={onSelect}
        vehicleControlList={vehicleControlList}
      />
    );
  } else {
    return (
      <VehicleControlTable
        name={UserVehicleControlDataName}
        vehicleControlList={vehicleControlList}
        onSelect={onSelect}
      />
    );
  }
};
